
export default {
  values: {
    xs: 0,
    sm: 360,
    md: 600,
    lg: 1024,
    xl: 1280,
  }
};
